import { render, staticRenderFns } from "./XLeftMenu.vue?vue&type=template&id=4056705a&scoped=true"
import script from "./XLeftMenu.vue?vue&type=script&lang=js"
export * from "./XLeftMenu.vue?vue&type=script&lang=js"
import style0 from "./XLeftMenu.vue?vue&type=style&index=0&id=4056705a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056705a",
  null
  
)

export default component.exports